import { jsx } from 'react/jsx-runtime';
import { size } from '../../constants.js';

const createIconFromRemixIcon = (RemixIcon)=>({ color, fixedSize, size: size$1 = "s6", ...extraProps })=>{
        return jsx(RemixIcon, {
            color: color,
            size: fixedSize || size[size$1],
            ...extraProps
        });
    };

export { createIconFromRemixIcon };
